import React from 'react';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import closeIcon from '../../../public/img/close-icon.svg';
import { humanizeNumber } from '../../helpers/formatters';

const factoids = [
  {
    label: 'people',
    key: 'people',
    icon: 'people-icon',
    format: 'number',
  },
  {
    label: 'median income',
    key: 'medianTotalIncome',
    icon: 'income-icon',
    format: 'currency',
  },
  {
    label: 'median age',
    key: 'medianAge',
    icon: 'age-icon',
    format: null,
  },
];

const MapBanner = ({ council, comparing, onCloseClicked }) => {
  return (
    <div
      className={`${styles.banner} ${styles.mapBanner}`}
      data-comparing={comparing}
    >
      <button className={styles.closeButton} onClick={onCloseClicked}>
        <img src={closeIcon} alt="" style={{ height: 10, width: 10 }} />
      </button>
      <h2 className={styles.mapBannerHeading}>{council.name}</h2>
      <div className={styles.mapBannerWrapper}>
        <div className={styles.mapBannerDataRow}>
          {factoids.map((f) => {
            return (
              <div
                className={styles.mapBannerDataBlockWrapper}
                style={{ marginRight: 40 }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/${f.icon}.svg`}
                  alt={`${f.label} icon`}
                  width="35"
                  height="46"
                />
                <div className={styles.mapBannerDataBlockContent}>
                  <div className={styles.mapBannerDataNumber}>
                    {f.format
                      ? humanizeNumber(council[f.key], 'number')
                      : council[f.key]}
                  </div>
                  <span>{f.label}</span>
                </div>
              </div>
            );
          })}
          <div className={styles.mapBannerInfoContainer}>
            <div className={styles.mapBannerInfo}>
              <span>{council.name} climate: </span>
              <span className={styles.mapBannerInfoValue}>
                {council.climateZoneDescription}
              </span>
            </div>
          </div>
          <div className={styles.mapBannerLegend}>
            <span> Demographic data was sourced from the</span>
            <a
              className={styles.externalLink}
              href="https://dbr.abs.gov.au/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Australian Bureau of Statistics data by region
            </a>
            <span>
              {' '}
              Climate zone information has been sourced from the 'Australian
              Building Codes Board' map which was created using Bureau of
              Meteorology climatic data. The climate zone boundaries are also
              aligned with local government areas.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

MapBanner.propTypes = {
  council: PropTypes.object,
};

export default MapBanner;



// WEBPACK FOOTER //
// ./src/components/region-map-container/map-banner.js